export const modalActions: React.CSSProperties = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 8,
  marginTop: 16,
};

export const modalBody: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
};
